export var MachineDocumentUploadingStatus;
(function (MachineDocumentUploadingStatus) {
    MachineDocumentUploadingStatus[MachineDocumentUploadingStatus["Pending"] = 0] = "Pending";
    MachineDocumentUploadingStatus[MachineDocumentUploadingStatus["Success"] = 1] = "Success";
    MachineDocumentUploadingStatus[MachineDocumentUploadingStatus["Failed"] = 2] = "Failed";
})(MachineDocumentUploadingStatus || (MachineDocumentUploadingStatus = {}));
